import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid } from '@mui/material'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';

// COMPONENTES
import MyTextInput from '../../../components/inputs/MyTextInput';
import MySwitchInput from '../../../components/inputs/MySwitchInput';

const EditarCorreo = ({ open, onClose, refresh, data }) => {

    const [ formValues, setFormValues ] = useState({
            
        email: '',
        is_active : ''

    });

    useEffect(() => {

        if(Object.keys(data).length > 0){

            setFormValues({

                email: data.email,
                is_active: data.is_active,
                id: data.id
    
            });

        }

    }, [data]);

    return (

        <Dialog
            open={open}
            onClose={onClose}
        >

            {/* HEADER */}

            <DialogTitle sx={{ textAlign: 'center' }}>
                Editar Correo
            </DialogTitle>

            {/* BODY */}

            <DialogContent sx={{ width: 300 }}>

                <Formik
                    initialValues={formValues}
                    enableReinitialize={true}
                    validationSchema={Yup.object({
                        email: Yup.string().email('Ingresa un correo valido').required('Ingresa un correo valido'),
                    })}
                    onSubmit={async (values, { setSubmitting, resetForm }) => {

                        try { console.log(values)

                            const response = await myApi.put('/emails/update', values);

                            if(response.data){

                                setSubmitting(false);
                                resetForm();
                                onClose();
                                refresh();

                                Swal.fire({
                                    icon: 'success',
                                    title: 'Correo Editado',
                                });

                            }

                        } catch(e) {

                            console.log(e);
                            setSubmitting(false);
                            resetForm();

                        }   

                    }}
                >
                {({ handleSubmit, values }) => (

                    <Form>

                        <Grid container spacing={2} marginTop={1}>

                            {/* CORREO */}

                            <Grid size={12}>

                                <MyTextInput
                                    name="email"
                                    label="Correo"
                                />

                            </Grid>

                            {/* ACTIVE */}

                            <Grid size={4} offset={4}>

                                <MySwitchInput
                                    name="is_active"
                                    label={values.is_active === 1 ? 'Activo' : 'Inactivo'}
                                />

                            </Grid>

                            {/* FOOTER */}

                            <Grid size={12}>

                                <DialogActions
                                    sx={{ justifyContent: 'space-between' }}
                                >

                                    <Button 
                                        type="submit" 
                                        variant="contained" 
                                        color="primary"
                                        onClick={handleSubmit}
                                    >
                                        Guardar
                                    </Button>

                                    <Button onClick={onClose}>Cancelar</Button>

                                </DialogActions>

                            </Grid>

                        </Grid>

                    </Form>

                )}
                </Formik>

            </DialogContent>

        </Dialog>

    )

}

export default EditarCorreo